// import { domain } from './var'

import main from './main'
const requestUrl = {
    main
}
export default requestUrl
